import { NativeLikeTooltip as Tooltip } from "@src/components/ui/native-like-tooltip";
import type React from "react";

interface SharePanelTooltipWrapperProps
	extends React.HTMLAttributes<HTMLDivElement> {
	isOverflowing: boolean;
	label: string;
}

export function SharePanelTooltipWrapper({
	isOverflowing,
	label,
	children,
}: SharePanelTooltipWrapperProps) {
	if (isOverflowing) {
		return (
			<Tooltip zIndex={9999} label={label} openDelay={500}>
				{children}
			</Tooltip>
		);
	}
	return <>{children}</>;
}
